import Cookie from './cookie.js';



/**
 * Cookie Consent helper class
 * Show Consent banner and save settings.
 * Provides Hooks for loading scripts after consent
 */
const CookieConsent = {
    
    cookieName: 'cookie-consent',
    defaults: {
        text: 'Cookies erleichtern die Bereitstellung unserer Dienste. Mit der Nutzung unserer Dienste erklären Sie sich damit einverstanden, dass wir Cookies verwenden.',
        acceptText: 'Akzeptieren',
        denyText: 'Ablehnen',
        onFirstTime: function() {},
        onConsent: function() {},
        onDeny: function() {}
    },

    init: function (config) { 
        this.config = [];
        for (var key in this.defaults) {
            if (key in config) {
                this.config[key] = config[key];
            } else {
                this.config[key] = this.defaults[key];
            }
        }
        
        
        if (Cookie.isSet(this.cookieName)) {
            // Cookie set            
            this.checkConsent();
                 
        } else {
            // First time
            this.config.onFirstTime();
            
            var that = this;
            window.addEventListener('DOMContentLoaded', function() {
                console.log('Show Consent Message');
                that.show();
            })
        }
    },

    show: function () {
        this.popup = document.createElement('div');
        this.popup.className = 'cookie-consent';
    
        var text = document.createElement('div');
        text.className = 'cookie-consent-text';
        text.innerHTML = this.config.text;
    
        var acceptBtn =  document.createElement('button');
        acceptBtn.className = 'cookie-consent-btn cookie-consent-btn--accept';
        acceptBtn.innerText = this.config.acceptText;
        acceptBtn.addEventListener('click', this.accept.bind(this));

        var denyBtn =  document.createElement('button');
        denyBtn.className = 'cookie-consent-btn cookie-consent-btn--deny';
        denyBtn.innerText = this.config.denyText;
        denyBtn.addEventListener('click', this.decline.bind(this));
        
        
        
        var btnGroup = document.createElement('div');
        btnGroup.className = 'cookie-consent-btn-group';
        
        if (this.config.denyText) {
            btnGroup.appendChild(denyBtn);
        }
        
        btnGroup.appendChild(acceptBtn);
        
    
        this.popup.appendChild(text);

        this.popup.appendChild(btnGroup);
        document.body.appendChild(this.popup);
    },

    hide: function () {
        document.body.removeChild(this.popup);
    },

    checkConsent: function () {
        if (Cookie.hasValue(this.cookieName, true)) {
            this.config.onConsent();
        } else {
            this.config.onDeny();
        }
    },

    decline: function () {
        Cookie.set(this.cookieName, false, 365, '/');
        this.hide();
        this.checkConsent();
    },

    accept: function () {    
        Cookie.set(this.cookieName, true, 365, '/');
        this.hide();
        this.checkConsent();
    },

    reset: function() {
        console.info('Consent cookies was reset');
        Cookie.set(this.cookieName, true, -1, '/');
    }
}

export default CookieConsent;